import { h, Component } from 'preact';
import style from './style';

export default class IframeVideoContainer extends Component {
  constructor(props) {
    super(props);
    let video = props.video;

    this.origin = props.domain
      ? props.domain
      : window.location.hostname === 'localhost'
      ? 'http://localhost:8080'
      : window.location.origin;
    this.url =
      window.location.hostname === 'localhost'
        ? `${this.origin}/${video.videoId}?${!props.stopAutoplay ? 'autoplay=1&' : ''}nologo=1&dp=1${props.enableBridge ? '&brg=1' : ''}`
        : `${this.origin}/videos/share/v2/${video && video.videoId}?${!props.stopAutoplay ? 'autoplay=1&' : ''}nologo=1&dp=1${props.enableBridge ? '&brg=1' : ''}`;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.video.videoId !== nextProps.video.videoId) {
      let video = nextProps.video;
      this.origin = nextProps.domain
        ? nextProps.domain
        : window.location.hostname === 'localhost'
        ? 'http://localhost:8080'
        : window.location.origin;
      this.url =
        window.location.hostname === 'localhost'
          ? `${this.origin}/${video.videoId}?${!nextProps.stopAutoplay ? 'autoplay=1&' : ''}nologo=1&dp=1${this.props.enableBridge ? '&brg=1' : ''}`
          : `${this.origin}/videos/share/v2/${video && video.videoId}?${!nextProps.stopAutoplay ? 'autoplay=1&' : ''}nologo=1&dp=1${this.props.enableBridge ? '&brg=1' : ''}`;
    }
  }

  render(props, state) {
    return (
      <div class={'iframeVideoWrapper'} style={props.iframeClipPath}>
        <div class={'iframeVideoContainer'}>
          <iframe src={this.url} allow={'autoplay'} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/spareparts/iframeVideo/index.js